import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierOptionsPanel from '../components/panels/CarrierOptionsPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierOptionsPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'optionPermission');

  return (
    <>
      <Layout
        carrierLoading={!selectedCarrier}
        menuIndex={isAdmin ? 1 : 0}
        routes={routes}
        showCarriersNavigation={isAdmin}
      >
        {canView && (
          <>
            <StickyPageHeader
              subtitle={selectedCarrier.name}
              title="Options"
            />
            <CarrierOptionsPanel
              carrier={selectedCarrier}
              id="options"
              userRole={authUser?.role}
            />
          </>
        )}
      </Layout>
    </>
  );
};

export default CarrierOptionsPage;
